import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '@dls/assets/icons';
import { Text, Modal, Button } from '@dls/web';
import { useState } from 'react';
import ReactDOM from 'react-dom';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var notifier;
(notifier2 => {
  notifier2.error = (message, onConfirm) => {
    ModalManager.open( /* @__PURE__ */jsxs(NotificationComponent, {
      buttonAlignment: "center",
      children: [/* @__PURE__ */jsx("div", {
        className: "my-4 d-flex justify-content-center text-danger",
        children: /* @__PURE__ */jsx(Icon, {
          name: "clear",
          size: 64,
          color: "currentColor"
        })
      }), /* @__PURE__ */jsx("div", {
        className: "mb-6 text-center",
        children: /* @__PURE__ */jsx(Text, {
          type: "body",
          children: message
        })
      })]
    }));
  };
  notifier2.success = (message, onConfirm) => {
    ModalManager.open( /* @__PURE__ */jsxs(NotificationComponent, {
      buttonAlignment: "center",
      children: [/* @__PURE__ */jsx("div", {
        className: "my-4 d-flex justify-content-center text-success",
        children: /* @__PURE__ */jsx(Icon, {
          name: "completed",
          size: 64,
          color: "currentColor"
        })
      }), /* @__PURE__ */jsx("div", {
        className: "mb-6 text-center",
        children: /* @__PURE__ */jsx(Text, {
          type: "body",
          children: message
        })
      })]
    }));
  };
  notifier2.warning = (message, onConfirm) => {
    ModalManager.open( /* @__PURE__ */jsxs(NotificationComponent, {
      buttonAlignment: "center",
      children: [/* @__PURE__ */jsx("div", {
        className: "my-4 d-flex justify-content-center text-warning",
        children: /* @__PURE__ */jsx(Icon, {
          name: "alert",
          size: 64,
          color: "currentColor"
        })
      }), /* @__PURE__ */jsx("div", {
        className: "mb-6 text-center",
        children: /* @__PURE__ */jsx(Text, {
          type: "body",
          children: message
        })
      })]
    }));
  };
  notifier2.info = (message, onConfirm) => {
    ModalManager.open( /* @__PURE__ */jsxs(NotificationComponent, {
      buttonAlignment: "center",
      children: [/* @__PURE__ */jsx("div", {
        className: "my-4 d-flex justify-content-center text-info",
        children: /* @__PURE__ */jsx(Icon, {
          name: "info",
          size: 64,
          color: "currentColor"
        })
      }), /* @__PURE__ */jsx("div", {
        className: "mb-6 text-center",
        children: /* @__PURE__ */jsx(Text, {
          type: "body",
          children: message
        })
      })]
    }));
  };
  notifier2.notify = (content, options) => {
    ModalManager.open( /* @__PURE__ */jsx(NotificationComponent, __spreadProps(__spreadValues({}, options), {
      children: content
    })));
  };
})(notifier || (notifier = {}));
var notifier$1 = notifier;
const NotificationComponent = props => {
  const [visible, setVisible] = useState(true);
  onCloseHandler = callback => {
    setVisible(false);
    setTimeout(callback, 400);
    onClose();
  };
  const onConfirm = () => {
    ModalManager.close();
    if (props.onConfirm) {
      props.onConfirm();
    }
  };
  const onClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };
  return /* @__PURE__ */jsx(Modal, {
    backdropClosable: false,
    visible,
    title: props.title,
    onClose: () => ModalManager.close(),
    wide: props.modalWide,
    children: /* @__PURE__ */jsxs(Modal.Content, {
      children: [typeof props.children === "string" ? /* @__PURE__ */jsx(Text, {
        children: props.children
      }) : props.children, /* @__PURE__ */jsx("div", {
        className: "mt-3".concat(getAlignmentClass(props.buttonAlignment)),
        children: /* @__PURE__ */jsx(Button, {
          fullWidth: props.buttonFullWidth,
          onClick: onConfirm,
          children: props.buttonText ? props.buttonText : "OK"
        })
      })]
    })
  });
};
const getAlignmentClass = alignment => {
  if (alignment === "center") return " text-center";else if (alignment === "right") return " text-end";
  return "";
};
var node;
var modals = [];
let onCloseHandler;
const renderModal = () => {
  if (modals.length === 0) return;
  const component = modals.shift();
  if (!node) {
    node = document.createElement("span");
    document.body.appendChild(node);
  }
  ReactDOM.render(component, node);
};
const ModalManager = {
  open(component) {
    modals.push(component);
    if (modals.length === 1) {
      renderModal();
    }
  },
  close() {
    onCloseHandler && onCloseHandler(() => {
      if (node) {
        ReactDOM.unmountComponentAtNode(node);
        node.remove();
        node = void 0;
      }
      renderModal();
    });
  }
};
export { ModalManager, notifier$1 as default };